import { Component } from "@angular/core";
import { Platform, PopoverController } from "@ionic/angular";

@Component({
  selector: "app-popover-social-share",
  templateUrl: "./popover-social-share.component.html",
  styleUrls: ["./popover-social-share.component.scss"],
})
export class PopoverSocialShareComponent {
  cordova: boolean = false;

  constructor(
    private platform: Platform,
    private popoverController: PopoverController
  ) {
    this.platform.ready().then(() => {
      this.cordova = this.platform.is("cordova");
    });
  }

  /**
   * Dismiss popover
   */
  async dismissPopover() {
    await this.popoverController.dismiss();
  }

  /**
   * Copy current page link to clipboard
   */
  copyLink() {
    if (typeof window !== "undefined" && window?.location) {
      document.addEventListener("copy", (e: ClipboardEvent) => {
        e.clipboardData.setData("text/plain", window.location.href);
        e.preventDefault();
        document.removeEventListener("copy", null);
      });
      document.execCommand("copy");

      this.dismissPopover();
    }
  }
}
